import { render, staticRenderFns } from "./AccountSelection.vue?vue&type=template&id=2bee88bc&"
import script from "./AccountSelection.vue?vue&type=script&lang=ts&"
export * from "./AccountSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports